export const queryDomainLocations = `
query DomainLocations($paging: CursorPaging, $filter: LocationFilter!) {
  domainLocations(paging: $paging, filter: $filter) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      node {
        address
        city
        country
        id
        lat
        long
        phone
        state
        timeZone
        zip
        isRootLocation
        }
      }
    }
  }
`
